import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';

const images = [
  'https://cdn.midjourney.com/4d652c0d-9334-4f45-af8b-f843af9a3e18/0_0.png',
  'https://cdn.midjourney.com/596f6ead-e70b-4424-86e6-4ae3e61fc9e5/0_0.png',
  'https://cdn.midjourney.com/48e6f32b-c41c-45eb-9bc7-4f36d3992ef9/0_3.png',
  'https://cdn.midjourney.com/bfd22058-cd37-47ab-a078-51c122eb6e48/0_0.png',
  'https://cdn.midjourney.com/6a397624-d0e4-446b-b18b-5d34e862502d/0_1.png',
  'https://cdn.midjourney.com/bc4a0d64-7408-4749-8b4e-e3f083128a78/0_3.png',
  'https://cdn.midjourney.com/e9b09e9d-8f0f-4b74-a9ab-3e4ab89b9ef2/0_0.png',
  'https://cdn.midjourney.com/cc17d2e8-c4cd-4fa3-a44e-ff390024160b/0_1.png',
  'https://cdn.midjourney.com/7bbf6007-a195-47b4-8717-80f3e4727880/0_2.png',
  'https://cdn.midjourney.com/cc17d2e8-c4cd-4fa3-a44e-ff390024160b/0_2.png',
];

export const slide = () => {
  return (
    <Slide notes="Masters magazine synthography examples" transition="fade">
      <div className="flex items-center justify-center h-full">
        <div className="grid grid-cols-5 gap-2 h-[90vh] w-[95vw]">
          {images.map((image, index) => (
            <WebContent
              key={image}
              animation={{
                type: 'slide-up',
                delay: index * 100,
                duration: 800,
              }}
            >
              <div
                className={`
                  h-full w-full 
                  bg-black/50 
                  rounded-xl 
                  overflow-hidden 
                  transform 
                  hover:scale-105 
                  transition-transform
                `}
              >
                <img
                  src={image}
                  alt={`Synthography ${index + 1}`}
                  className="h-full w-full object-cover"
                />
              </div>
            </WebContent>
          ))}
        </div>
      </div>
    </Slide>
  );
};
